
import { nextTick, reactive } from 'vue';
import { Options, Vue } from 'vue-class-component';
import { Prop, Ref, Watch } from 'vue-property-decorator';
import NText from '@/uikit/text/NText.vue';
import { dataModule } from '@/store/data';

@Options({
  name: 'TableItemCameraGroups',
  components: { NText }
})
export default class TableItemCameraGroups extends Vue {
  @Prop({ type: Array, required: true })
  readonly modelValue!: number[];

  content = '...';

  async getContent() {
    if (!Array.isArray(this.modelValue)) return '-';
    const groups = await dataModule.cameraGroupsModule.getByIds(this.modelValue);
    return groups.map((v) => v?.name)?.join(', ');
  }

  @Watch('modelValue', { immediate: true })
  async load() {
    this.content = '...';
    this.content = await this.getContent();
  }
}
